module.exports = {
  multi_link: {
    form_model: '', // 关联数据表
    filter: {
      condition: [],
      relation: ''
    }, // 筛选条件
    size: '',
    // width: 600, // 弹窗宽度
    // height: 400, // 弹窗高度
    search: [], // 搜索条件配置
    page_size: 10, // 单页数据
    select_type: 10, // 10:单选｜20:多选
    min_select_num: 0, // 最小选择数量
    max_select_num: 0, // 最大选择数量
    display_fields: [] // 显示字段
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/multiRelate.js